<template>
  <div>
    <div>
      <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
        <el-form-item label="产品名称">
          <el-input v-model="goods_name" placeholder="请输入产品名称（必填）" @blur="checkgname">
            <i v-if="gnameok" slot="suffix" style="color: green;" class="el-input__icon el-icon-check"></i>
            <i v-else slot="suffix" style="color: red;" class="el-input__icon el-icon-close"></i>
          </el-input>
        </el-form-item>
        <el-form-item validate-event label="产品编码">
          <el-input v-model="goods_barcode" placeholder="请输入产品编号（BarCode）（必填）" @blur="checkgbarcode">
            <i v-if="gbarcodeok" slot="suffix" style="color: green;" class="el-input__icon el-icon-check"></i>
            <i v-else slot="suffix" style="color: red;" class="el-input__icon el-icon-close"></i>
          </el-input>
        </el-form-item>
        <el-form-item validate-event label="标准售价">
          <el-input v-model="goods_baseprice" placeholder="请输入产品价格范围（必填）" @blur="checkprice">
            <i v-if="bpriceok" slot="suffix" style="color: green;" class="el-input__icon el-icon-check"></i>
            <i v-else slot="suffix" style="color: red;" class="el-input__icon el-icon-close"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="价格范围文字">
          <el-input v-model="goods_basepricetxt" placeholder="请输入产品价格范围文字（必填）" @blur="checkparea">
            <i v-if="gpareaok" slot="suffix" style="color: green;" class="el-input__icon el-icon-check"></i>
            <i v-else slot="suffix" style="color: red;" class="el-input__icon el-icon-close"></i>
          </el-input>
        </el-form-item>
        <el-form-item validate-event label="显示次序">
          <el-input v-model="ed_goodsindex" placeholder="请输入显示次序 （非必填）"></el-input>
        </el-form-item>
        <el-form-item  label="产品分类">
          <el-input v-model="ed_goodstype" :disabled="true" @focus="showgtype" placeholder="请选择产品分类（必填）">
            <el-button slot="append" @click="showgtype" icon="el-icon-search"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="产品品牌">
          <el-input v-model="ed_goodsbrand" :disabled="true" @focus="showgbrand" placeholder="请选择产品品牌（必填）">
            <el-button slot="append" @click="showgbrand" icon="el-icon-search"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button style="margin-left: 20px;" type="primary" icon="el-icon-edit-outline" @click="savegoodsinfo" round>保存新产品</el-button>
      <el-button style="margin-left: 10px;" type="danger" icon="el-icon-delete" @click="delgoods" round>删除该产品</el-button>
    </div>
    <el-dialog :modal="smodel" title="产品品牌" :visible.sync="gbpanelvisible" @close="closegbpanel">
      <GBrand ref="gbrand" @loadgbrand="loadgbrand"></GBrand>
    </el-dialog>
    <el-dialog :modal="smodel" title="产品分类列表" :visible.sync="gtpanelvisible" @close="closegtpanel">
      <GTypeList ref="curgtl" @loadgtype="loadgtype"></GTypeList>
    </el-dialog>
  </div>
</template>

<script>
  import GTypeList from './GTypeList'
  import GBrand from './GBrand'
  var that
  export default {
    name: 'GoodsBase',
    components: {
      GTypeList,
      GBrand
    },
    data () {
      return {
        goods_name: '',
        goods_barcode: '',
        smodel: false,
        goodstype: '',
        goodsbrand: '',
        ed_goodstype: '',
        ed_goodstypeid: '',
        goodstypelist: [],
        goodsbrandlist: [],
        gtpanelvisible: false,
        shownextbt: false,
        cusgoodsdata: [],
        ed_goodsindex: '',
        ed_goodsbrand: '',
        ed_goodsbrandid: '',
        goods_baseprice: '',
        selectgoodstype: '',
        goods_basepricetxt: '',
        eidt_id: -1,
        gbpanelvisible: false,
        curbrand: '',
        curbrandid: '',
        curtypelist: '',
        khid: '',
        curtypeidlist: '',
        gnameok: false,
        gbarcodeok: false,
        bpriceok: false,
        gpareaok: false,
        sgoods: ''
      }
    },
    created: function () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.eidt_id = localStorage.getItem('editgoodsid')
        that.getgoodsinfo(that.eidt_id)
      }
    },
    methods: {
      delgoods () {
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delginfo',
          method: 'post',
          data: {
            id: localStorage.getItem('editgoodsid').toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$emit('qgoods');
              that.$emit('colsepage');
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      showbaseinfo (val) {
        // 以前代码已经迁移
        that.getgoodsinfo(val)
      },
      getgoodsinfo (val) {
        var qstr = {
          whereinfo: 'id =' + val,
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              var tmpdata = res.data
              window.console.log(tmpdata)
              localStorage.setItem('curegdata',JSON.stringify(tmpdata))
              that.$emit('qgoods');
              that.sgoods = tmpdata[0]
              that.goods_name = tmpdata[0].name
              that.goods_barcode = tmpdata[0].barcode
              that.goods_baseprice = tmpdata[0].baseprice
              that.goods_basepricetxt = tmpdata[0].pricetxt
              that.ed_goodsindex = tmpdata[0].goodsindex
              that.gnameok = true
              that.gbarcodeok = true
              that.bpriceok = true
              that.gpareaok = true
              that.ed_goodstypeid = tmpdata[0].goods_type_id
              that.ed_goodsbrandid = tmpdata[0].brand_id
              that.getgoodstype(tmpdata[0].goods_type_id)
              that.getgoodsbrand(tmpdata[0].brand_id)
            } else {
              that.goods_name = ''
              that.goods_barcode = ''
              that.goods_baseprice = ''
              that.goods_basepricetxt = ''
              that.ed_goodsindex = ''
              that.ed_goodstype = ''
              that.ed_goodsbrand = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getgoodsbrand (val) {
        var qstr = {
          whereinfo: 'id =' + val,
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygbrand',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          console.log('已获取网络数据')
          if (res.data.length > 0) {
            that.curbrandid = res.data[0].id
            that.ed_goodsbrand = res.data[0].name
          } else {
            that.ed_goodsbrand = ''
          }
        })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getgoodstype (val) {
        var qstr = {
          whereinfo: "ownphone ='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/quergtype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化分类数据******************')
            if (res.data.length > 0) {
              var tmpdata = JSON.parse(res.data[0].typetree)[0].children
              window.console.log('获取分类',tmpdata)
              var ids = val.split(',')
              that.curtypelist = []
              that.curtypeidlist = []
              for (var i = 0; i < ids.length; i++) {
                var dataindex = tmpdata.findIndex(d => parseInt(d.id) === parseInt(ids[i]))
                window.console.log('序号',dataindex)
                that.curtypeidlist.push(tmpdata[dataindex].id)
                that.curtypelist.push(tmpdata[dataindex].name)
              }
              that.ed_goodstype = that.curtypelist.join(',')
            } else {
              that.ed_goodstype = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      // 显示产品分类
      showgtype () {
        that.gtpanelvisible = true
      },
      // 显示产品品牌
      showgbrand () {
        this.gbpanelvisible = true
      },
      loadgbrand (val) {
        window.console.log('获取的品牌')
        window.console.log(val)
        if (val !== null) {
          this.curbrand = val
          this.ed_goodsbrandid = val.id
          this.ed_goodsbrand = this.curbrand.name
          this.gbpanelvisible = false
        }
      },
      // 分类子控件返回数据
      loadgtype (val) {
        window.console.log(val)
        this.gtpanelvisible = false
        this.curtypelist = []
        this.curtypeidlist = []
        if (val.length>0) {
          for (var i = 0; i < val.length; i++) {
            this.curtypeidlist.push(val[i].id)
            this.curtypelist.push(val[i].name)
          }
          this.ed_goodstype = this.curtypelist.join(',')
        } else {
          this.ed_goodstype = val.data.name
          this.curtypelist.push(val.data.name)
          this.curtypeidlist.push(val.data.id)
        }
        that.$refs.curgtl.closemain()
      },
      // 关闭产品分类面板
      closegtpanel () {
        that.$refs.curgtl.closemain()
      },
      // 关闭品牌面板
      closegbpanel () {
        that.$refs.gbrand.refreshdata()
      },
      savegoodsinfo () {
        window.console.log(this.gnameok)
        window.console.log(this.gbarcodeok)
        window.console.log(this.bpriceok)
        window.console.log(this.gpareaok)
        window.console.log(this.curbrandid)
        window.console.log(this.curtypeidlist)
        if (this.gnameok && this.gbarcodeok && this.bpriceok && this.gpareaok && this.ed_goodsbrandid) {
          var tmptype = ''
          var tmptypeids = ''
          if (this.curtypeidlist.length > 0) {
            tmptypeids = this.curtypeidlist.join(',')
            tmptype = this.curtypelist.join(',')
          } else {
            tmptypeids = this.curtypeidlist[0]
            tmptype = this.curtypelist[0]
          }
          var goodsobj = {
            id: that.eidt_id.toString(),
            barcode: this.goods_barcode,
            name: this.goods_name,
            goods_type_id: tmptypeids,
            goods_types: tmptype,
            goods_type_tmp_id: '0',
            goodsindex: this.ed_goodsindex.toString(),
            brand_id: this.ed_goodsbrandid.toString(),
            brandname: this.ed_goodsbrand.toString(),
            baseprice: this.goods_baseprice.toString(),
            cusid: this.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/addginfo',
            method: 'post',
            data: goodsobj,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.result === 'success') {
                /// 保存价格范围
                var uppricedata = {
                  goodsid: that.eidt_id.toString(),
                  pricetxt: that.goods_basepricetxt,
                  ownphone: localStorage.getItem('username'),
                  cusid: that.khid.toString()
                }
                that.$http({
                  url: 'https://ecommapi.sqnetsoft.cn/addgpricearea',
                  method: 'post',
                  data: uppricedata,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.result === 'success') {
                      that.$message({
                        type: 'success',
                        message: '更新产品完毕'
                      })
                    }
                  })
              } else {
                that.$message({
                  type: 'error',
                  message: '添加产品失败'
                })
              }
            })
        } else {
          that.$message({
            type: 'error',
            message: '信息不完整，无法添加'
          })
        }
      },
      gnextattr () {
        that.$emit('nextattr',that.eidt_id);
      },
      checkgname() {
        if (that.goods_name !== '') {
          that.gnameok = true
        } else {
          that.gnameok = false
          that.$message({
            type: 'error',
            message: '产品名称不允许为空'
          })
        }
      },
      checkgbarcode () {
        if (that.goods_barcode !== '') {
          that.gbarcodeok = true
        } else {
          that.gbarcodeok = false
          that.$message({
            type: 'error',
            message: '产品编码不允许为空'
          })
        }
      },
      checkparea () {
        if (that.goods_basepricetxt !== '') {
          that.gpareaok = true
        } else {
          that.gpareaok = false
          that.$message({
            type: 'error',
            message: '价格范围不允许为空'
          })
        }
      },
      checknumstr() {
        if (that.goods_name !== '') {
          that.gnameok = true
        } else {
          that.gnameok = false
          that.$message({
            type: 'error',
            message: '产品名称不允许为空'
          })
        }
      },
      // 验证方式
      checkprice() {
        let reg = /(^[\d]|^[1-9][\d]*)($|[\\.][\d]{0,2}$)/;
        if (that.goods_baseprice !== '') {
          if (new RegExp(reg).test(that.goods_baseprice) === false) {
            that.bpriceok = false
            that.$message({
              type: 'error',
              message: '售价只允许输入数字'
            })
          } else {
            that.bpriceok = true
          }
        } else {
          that.bpriceok = false
          that.$message({
            type: 'error',
            message: '售价不允许为空'
          })
        }
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>
  .el-drawer__header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #72767b;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* margin-bottom: 32px; */
    padding: 20px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/newgoods/EGoodsBase.vue